define([
    'WebCommon/utils',
    'vue',
    'jquery',
    'vueLazyload',
    'vueI18n',
    'web/common/plugin/vue-custom',

    'WebCommon/menu/menu',
    'css!web/common/css/lazyload.css'
], function(
    Utils,
    Vue,
    $,
    VueLazyload,
    VueI18n,
    VueCustom
){
    Vue.use(VueLazyload, {
        preLoad: 1
    });
    Vue.use(VueI18n);
    Vue.use(VueCustom);

    Vue.prototype.V2 = {cdn:'http://static-test.fnji.com'}
    Vue.prototype.V1 = {cdn:'https://static.fnji.com'}

    $(document).on('click', 'a[href="#"]', function(e){
        e.preventDefault();
    });
});


//////////////////
// WEBPACK FOOTER
// ../common/init.js
// module id = 16
// module chunks = 0 1 2 3 4 5 6 7 8 9